require('./brokerMarketsIndexesDetailView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxSectionContent } = require('commonsComponents/OKBoxSectionContent');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { BrokerTableIndexesDetail } = require('./brokerTableIndexesDetail/brokerTableIndexesDetail');
const Flag = require('components/broker/commons/flag/flag');

// @actions
const brokerMarketsActions = require('actions/brokerMarkets');
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');
const BrokerAllIndexesActions = require('actions/brokerAllIndexes');

// @helpers
const { buildArrowIcon } = require('utilities/brokerMarketsHelper');
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { BROKER_LARGE_FLAG_SIZE } = require('constants/index');

const BREADCRUMB = [
    {
        text: <FormattedText value="brokerMarketNews-savingsTitlte" />,
        url: '/myprofile/broker'
    },
    {
        text: <FormattedText value="broker-marketsTitle" />,
        url: '/myprofile/broker/markets'
    },
    {
        text: <FormattedText value="brokerMarketNews-indexesValuesTitle" />,
        url: '/myprofile/broker/markets/indexes'
    },
    {
        text: <FormattedText value="brokerMarketNews-lastNewsTitle" />,
        url: 'Valores de un índice'
    }
];

class BrokerMarketsIndexesDetailView extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            optionSelected: props.match.params.idIndex,
            stocksIndex: null
        }
        this.updateState = this.updateState.bind(this);
    }

    componentDidMount() {
        const { immBrokerExchangeIndexes, getIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('indexes').size === 0) {
            getIndexes();
        } else {
            this.updateIndexStock();
        }
    }

    componentDidUpdate() {
        const { stocksIndex, optionSelected } = this.state;
        const { immBrokerExchangeIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('indexes').size > 0) {
            if (!immBrokerExchangeIndexes.get('byId'))
                this.updateIndexStock();

            if(!stocksIndex && immBrokerExchangeIndexes.get('byId') && immBrokerExchangeIndexes.getIn(['byId', optionSelected]) && immBrokerExchangeIndexes.getIn(['byId', optionSelected, 'stocks'])) {
                this.updateState({
                    stocksIndex: immBrokerExchangeIndexes.getIn(['byId', optionSelected, 'stocks']).toJS()
                })
            }
        }
    }

    updateState(newState) {
        this.setState(newState);
    }

    updateIndexStock = () => {
        const { optionSelected } = this.state;
        const { immBrokerExchangeIndexes, getStocksByIndex } = this.props;
        const currentIndexInformation = immBrokerExchangeIndexes.get('indexes').toJS().filter(d => d.name === optionSelected)[0];

        getStocksByIndex({
            exchangeId: currentIndexInformation.exchangeId,
            spcSymbol: currentIndexInformation.spcSymbol,
            selectedMarket: currentIndexInformation.name
        });
    }

    handleChangeIndex = (option) => {
        this.setState({
            optionSelected: option.value,
            stocksIndex: null
        }, () => {
            this.updateIndexStock();
        });
    }

    buildOptionSelect = () => {
        const { immBrokerExchangeIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('indexes').toJS().length > 0) {
            const options = immBrokerExchangeIndexes.get('indexes').toJS().map((data) => {
                const optionLabel = (
                    <React.Fragment>
                        <Flag countryCode={data.countryCode} pixelsSize={BROKER_LARGE_FLAG_SIZE} />
                        <span className="broker-markets-index-detail__header-select-label">
                            {data.name}
                        </span>
                    </React.Fragment>
                )
                return (
                    {
                        label: optionLabel,
                        value: data.name
                    }
                )
            })
            return options;
        }

        return null;
    }

    buyStockIndex = (isin) => {
        this.props.history.push(`/myprofile/broker/fund/isin/${isin}`);
    }

    buildOtherIndexesTable = () => {
        const { stocksIndex } = this.state;

        return (
            <BrokerTableIndexesDetail
                buildArrowIcon={buildArrowIcon}
                stocksIndex={stocksIndex}
            />
        )
    }

    buildContent = () => {
        const { optionSelected } = this.state;
        const table = this.buildOtherIndexesTable();
        const { stocksIndex } = this.state;

        return (
            <React.Fragment>
                <div className="broker-markets-index-detail__header">
                    <strong className="broker-markets-index-detail__header__title">Valores del índice</strong>
                    <div className="broker-markets-index-detail__header__select">
                        <OKSelect
                            onChange={this.handleChangeIndex}
                            options={this.buildOptionSelect()}
                            value={optionSelected}
                            searchable={false}
                            clearable={false}
                        />
                    </div>
                </div>
                <div className="broker-markets-index-detail__table">
                    {stocksIndex ?
                        table
                        :
                        <div className="broker-markets-index-detail__loading-section">
                            <LoadingSection />
                        </div>
                    }
                </div>
            </React.Fragment>
        )
    }

    render() {
        const indexValues = this.buildContent();

        return (
            <div className="broker-markets-index-detail">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={BREADCRUMB}
                                finalTitle="Valores de un índice"
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="broker-markets-index-detail__container">
                                <OKBoxSectionContent
                                    content={
                                        indexValues
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerMarketsIndexesDetailView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerMarket: PropTypes.object,
    requestIndexesData: PropTypes.func,
    getIndexes: PropTypes.func,
    immBrokerExchangeIndexes: PropTypes.object,
    immBrokerAllIndexes: PropTypes.object,
    onFetchingIndexes: PropTypes.func,
    getStocksByIndex: PropTypes.object,
    match: PropTypes.object,
};

module.exports.constructor = BrokerMarketsIndexesDetailView;
module.exports.BrokerMarketsIndexesDetailView = connect(
    state => ({
        immBrokerMarket: state.brokerMarkets,
        immBrokerExchangeIndexes: state.brokerExchangeIndexes,
        immBrokerAllIndexes: state.brokerAllIndexes,
    }), {
        requestIndexesData: brokerMarketsActions.requestIndexesData,
        getStocksByIndex : brokerTodaysMainStocksActions.getStocksByIndex,
        getIndexes: brokerTodaysMainStocksActions.getIndexes,
        onFetchingIndexes: BrokerAllIndexesActions.fetchIndexes,
})(withRouter(BrokerMarketsIndexesDetailView));
